import styled from 'styled-components';
import MembershipTable from './MembershipTable';
import MembershipDetailTable from './MembershipDetailTable';
import MembershipCard from './MembershipCard';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { useState } from 'react';

const MembershipManagement = () => {
  const [registeredCard, setRegisteredCard] = useState({
    cardname: '',
    cardnumber: ''
  });

  return (
    <Wrapper>
      <BizTitleWrapper>
        <MembershipTable />
      </BizTitleWrapper>
      <BizTitleWrapper>
        <MembershipDetailTable registeredCard={registeredCard} />
      </BizTitleWrapper>
      <BizTitleWrapper>
          <MembershipCard setRegisteredCard={setRegisteredCard} />
      </BizTitleWrapper>
    </Wrapper>
);
};

export default MembershipManagement;

const Wrapper = styled.div`
  color: ${color.black2};

  h2 {
    ${font.h2_bold};
  }

  & > h2:not(first-of-type) {
    margin-bottom: 24px;
  }

  & > p {
    ${font.body_regular};
    margin: 16px 0 24px;
  }

  th {
    vertical-align: middle;
    text-align: center !important;

    &:first-of-type {
      width: 360px;
    }
  }

  .ant-table-wrapper .ant-table-pagination.ant-pagination {
    margin: 16px 0 48px;
  }
`;

const BizTitleWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 10px;
`;
